enum PaymentMethod {
	Undefined = -1,
	Skipped = 0,
	DebitCreditCard = 1,
	Paypal = 2,
	Coupon = 3,
	Cash = 4,
	Oxxo = 5,
	Check = 6,
	MoneyOrder = 7,
	BackofficeDebitCreditCard = 8,
	ApplePay = 9,
	BankTransfer = 10,
	PayrollCharge = 11,
	FarmaciasAhorro = 12,
	FarmaciasBenavides = 13,
	GooglePay = 14,
	SevenEleven = 15,
	TransferAdjustment = 16
}

export default PaymentMethod;
